<template>
  <v-btn
    color="primary"
    outlined
    :loading="loading"
    @click="makeDownload()"
  >
    <v-icon>mdi-download</v-icon>
    Baixar
  </v-btn>
</template>

<script>
import ServiceMixin from '@/app/arch/mixins/ServiceMixin';
import DownloadMixin from '@/app/arch/mixins/DownloadMixin';
import TemplatesRequest from '../TemplatesRequest';

export default {
  name: 'TerminateButton',
  mixins: [ServiceMixin, DownloadMixin],
  props: {
    template: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    requestClass: TemplatesRequest,
    loading: false,
    config: {
      errorMessage: 'Falha ao tentar fazer download de template',
      showSuccessSwal: false,
      showErrorSwal: true,
    },
  }),
  methods: {
    makeDownload() {
      this.loading = true;
      this.getTemplate();
    },
    getTemplate() {
      this.callService(
        this.requestClass.terminate(
          this.template,
        ),
        this.setFileToExport,
        this.config,
      );
    },
    setFileToExport(response) {
      this.loading = false;
      this.setFile(response);
    },
    setFile(response) {
      if (response && response.data) {
        this.makePdfToDownload(response.data);
      }
    },
    makePdfToDownload(file) {
      this.createFile(
        [file],
        'application/pdf',
        'text/plain',
        'template_pdf.pdf',
      );
    },
  },
};
</script>

<style>

</style>
